import { combineReducers } from 'redux'
import reducerApp from './reducer'
import users from '../pages/Users/reducer'
import products from '../pages/Products/reducer'
import orders from '../pages/Orders/reducer'
import banners from '../pages/Banners/reducer'
import topProducts from '../pages/TopProducts/reducer'
import brands from '../pages/Brands/reducer'
import categories from '../pages/Categories/reducer'
import catalogs from '../pages/Catalogs/reducer'
import subscriptions from '../pages/Subscriptions/reducer'
import dashboard from '../pages/Dashboard/reducer'
import abandonedCarts from '../pages/AbandonedCarts/reducer'

const reducer = combineReducers({
  reducerApp,
  users,
  products,
  orders,
  banners,
  topProducts,
  brands,
  categories,
  catalogs,
  subscriptions,
  dashboard,
  abandonedCarts,
})

export default reducer
